import noop from '@picsart/rc/noop';

var callbacksResolver = function callbacksResolver(cb, count) {
  var promises = [];
  var callBacks = new Array(count).fill(undefined).map(function () {
    var callback = noop;
    promises.push(new Promise(function (resolve) {
      return callback = resolve;
    }));
    return callback;
  });
  Promise.all(promises).then(cb);
  return callBacks;
};

export { callbacksResolver as default };
